<mat-form-field appearance="outline" class="{{ cssClass }}" [formGroup]="inputFormGroup">
  <input matInput formControlName="input" type="{{ type }}" [placeholder]="placeHolder" (input)="sendSearchQuery()" />
  <svg-icon src=" {{ icon }} " [svgStyle]="{ 'width.px': 16 }" [class]="'icon'" (click)="clearSearch()"></svg-icon>
</mat-form-field>
